import { render } from "./LightspeedAuth.vue?vue&type=template&id=5fe1ad07&ts=true"
import script from "./LightspeedAuth.vue?vue&type=script&lang=ts"
export * from "./LightspeedAuth.vue?vue&type=script&lang=ts"

import "./LightspeedAuth.vue?vue&type=style&index=0&id=5fe1ad07&lang=scss"

import exportComponent from "/github/workspace/merchant/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__